import React from "react"

import ModalsDrawer from "../../Modals/ModalsDrawer"
import { withAccountDrawer } from "./withAccountDrawer"
import { Dashboard } from "../Dashboard/Dashboard"
import { CustomerOrders } from "../../Customer/Orders/CustomerOrders"

export const AccountDrawer = withAccountDrawer(
  ({ activeAccount, handleAccountActive, ordersPage }): JSX.Element => (
    <ModalsDrawer active={activeAccount} setActive={handleAccountActive} right noClose>
      <Dashboard drawer={`true`}>
        <CustomerOrders page={ordersPage} />
      </Dashboard>
    </ModalsDrawer>
  )
)
